module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC08_ua.e02e13d1.webp";